import { render, staticRenderFns } from "./TemplateHighlightSectionMobile.vue?vue&type=template&id=32d9a532&scoped=true&"
import script from "./TemplateHighlightSectionMobile.vue?vue&type=script&lang=js&"
export * from "./TemplateHighlightSectionMobile.vue?vue&type=script&lang=js&"
import style0 from "./TemplateHighlightSectionMobile.vue?vue&type=style&index=0&id=32d9a532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d9a532",
  null
  
)

export default component.exports